import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../../app/stores/store'
import { currencyValue, formatCurrency } from '../muiStyle/muiStyle'
import { formatToLocalDate } from '../../../app/helpers'

function AuctionReview({ handleClose }: any) {
  const { bidsStore } = useStore()
  const { auctionDetails } = bidsStore
  const { roundNumber, winner, totalRounds, deadline, bids, status } =
    auctionDetails!
  const { price, currency } = auctionDetails!.post!
  const { t, i18n } = useTranslation()

  const currencyName = currencyValue.find((item) => item.value === currency)
    ?.name

  return (
    <>
      <Modal.Header className="bg-white auction-review">
        <h3 className="modal-title">{t('auction_details')}</h3>
      </Modal.Header>
      <Modal.Body className="post-card-padding pt-4 card-font-size">
        <div className="winner-info mt-2">
          <h4 className="text-center mb-3">
            {winner
              ? `${t('winner_info')}:`
              : `${t('auction_round')} ${roundNumber}/${totalRounds}`}
          </h4>
          {winner ? (
            <div className="winner-details">
              <p>
                <strong>{t('email')}:</strong> {winner}
              </p>
              <p>
                <strong>{t('round')}:</strong> {roundNumber}/{totalRounds}
                {winner && ` - ${t('final_round')}`}
              </p>
              <p>
                <strong>{t('auction_ended')}:</strong>{' '}
                {formatToLocalDate(deadline, i18n.language)}
              </p>
              {roundNumber !== totalRounds && winner && (
                <>
                  {status === 4 ? (
                    <p>
                      {t('auction_review1')}{' '}
                      <strong>
                        {`${formatCurrency(price)} ${currencyName}`}
                      </strong>
                      . {t('auction_review2')}
                    </p>
                  ) : bids?.length ? (
                    <p>{t('auction_review3')}</p>
                  ) : (
                    <p>{t('auction_review4')}</p>
                  )}
                </>
              )}
            </div>
          ) : roundNumber == 1 && bids && bids.length > 0 ? (
            <p>{t('auction_review5')}</p>
          ) : (
            <p>{t('auction_review6')}</p>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-start">
        <button
          onClick={() => handleClose()}
          className="payment-button-cancel text-white"
        >
          {t('close')}
        </button>
      </Modal.Footer>
    </>
  )
}
export default observer(AuctionReview)
